<template>
  <el-dialog title="映射关系设置" :visible.sync="dialogVisibleSetRelevance" width="50%">
        <el-form :model="queryParams" label-width="120px">
            <el-form-item label="系统表头名称：">
                {{queryParams.header}}
            </el-form-item>
            <el-form-item label="供应商表头名称：">
                <el-input type="textarea" onkeyup="value=value.replace(/[^\\a-\z\A-\Z0-9\u4E00-\u9FA5\;\；]/g,'')" v-model="queryParams.supplierHeader" placeholder="请输入对应的功能供应商报价单表头名称,多个名称以;间隔"></el-input>
            </el-form-item>
        </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onConfirm">确 定</el-button>
        <el-button @click="dialogVisibleSetRelevance= false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { supplierHeaderTemplateAdd } from '@/api/supplier/supplierManage'
export default {
  data () {
    return {
      dialogVisibleSetRelevance: false,
      queryParams: {}
    }
  },
  methods: {
    onsetRelevance (row) {
      this.queryParams = JSON.parse(JSON.stringify(row))
      this.dialogVisibleSetRelevance = true
    },
    // 确定
    onConfirm () {
      const params = {
        supplierHeader: this.queryParams.supplierHeader,
        header: this.queryParams.header
      }
      supplierHeaderTemplateAdd(params).then(res => {
        if (res.data.code === 200) {
          this.$emit('onGetList')
          this.dialogVisibleSetRelevance = false
          this.$message.success('关联成功!')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
